
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';
import i18next from 'i18next';

import './CssEditor.scss';

class CssEditor extends Component {
    state = { cssRawData: '' };

    handleApprove = () => {
        this.props.onClose();
        this.props.onSave(this.state.cssRawData);
    }

    render() {
        const { open, onClose } = this.props;
        const cssRawData = this.state.cssRawData || this.props.cssRawData;
        
        return (
            <Modal open={open} onClose={onClose} className="brand-css-editor">
                <Modal.Header>{i18next.t('brands.editBrandCss')}</Modal.Header>
                <Modal.Content image>
                    <Modal.Description>
                        <textarea 
                            className="css-text-area" 
                            spellCheck={false} 
                            value={cssRawData} 
                            onChange={({ target }) => this.setState({ cssRawData: target.value })}
                        />
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='black' onClick={onClose} basic>
                        {i18next.t('cancel')}
                    </Button>
                    <Button
                        positive                        
                        icon='checkmark'
                        labelPosition='right'
                        content={i18next.t('save')}
                        onClick={this.handleApprove}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

CssEditor.propTypes = {
    
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    cssRawData: PropTypes.string
};

export default CssEditor;
